import 'flowbite'
import Rails from '@rails/ujs'
import 'active_admin/features/batch_actions'
import 'active_admin/features/has_many'
import 'active_admin/features/filters'
import 'active_admin/features/main_menu'
import 'active_admin/features/per_page'

Rails.start()

import { adminStimulus } from './admin/stimulus_application.js'
import TagifyController from './admin/tagify_controller.js'
import TomSelectController from './admin/tom_select_controller.js'
import UppercaseController from './admin/uppercase_controller.js'
import MaxDigitsController from './admin/max_digits_controller.js'
import PatchTotalController from './admin/patch_total_controller.js'
import DatePickerController from './admin/date_picker_controller.js'

adminStimulus.register('tagify', TagifyController)
adminStimulus.register('tom-select', TomSelectController)
adminStimulus.register('uppercase', UppercaseController)
adminStimulus.register('max-digits', MaxDigitsController)
adminStimulus.register('patch-total', PatchTotalController)
adminStimulus.register('date-picker', DatePickerController)